import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';

export const Content = styled('div')`
  box-sizing: border-box;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 30px;
  height: 100%;
  max-width: 960px;
  padding: 15px 30px;
  width: 100%;

  @media (max-width: ${breakpoints.tablet}) {
    height: fit-content;
    padding: 0;
    width: 100%;
  }
`;

export const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
    align-items: stretch;
    width: 100%;

    > * {
      width: 100%;
    }
  }
`;

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding-bottom: 40px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SiteCard = styled.div`
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  overflow: hidden;
  background-color: white;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media (max-width: ${breakpoints.tablet}) {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
  }
`;

export const SiteHeader = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex: 1;
  justify-content: space-between;
  gap: 15px;
  padding: 24px;
  width: 100%;

  @media (max-width: ${breakpoints.tablet}) {
    align-items: flex-start;
    flex-direction: column;
    padding: 16px;
  }
`;

export const SiteHeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  @media (max-width: ${breakpoints.tablet}) {
    align-items: flex-start;
    flex-direction: column;
    gap: 3px;
  }
`;

export const Divider = styled.div`
  border-bottom: 1px solid ${colours.neutral[300]};
  margin: 16px 0;
`;

export const SiteContent = styled.div`
  width: 100%;
  overflow: auto;
  height: 100%;
  padding: 0 0 30px 0;
  box-sizing: border-box;
`;

export const NoShiftsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const NoShiftsIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background-color: ${colours.neutral[200]};
  border-radius: 50%;
  margin-bottom: 24px;
  color: ${colours.neutral[500]};
`;
